import {
  FETCH_SEO_META_REQUEST,
  FETCH_SEO_META_SUCCESS,
  FETCH_SEO_META_FAILURE,
  FETCH_SEO_LINKS_BLOCKS_REQUEST,
  FETCH_SEO_LINKS_BLOCKS_SUCCESS,
  FETCH_SEO_LINKS_BLOCKS_FAILURE,
  FETCH_SEO_TEXTS_BLOCKS_REQUEST,
  FETCH_SEO_TEXTS_BLOCKS_SUCCESS,
  FETCH_SEO_TEXTS_BLOCKS_FAILURE,
  FETCH_BREADCRUMBS_REQUEST,
  FETCH_BREADCRUMBS_SUCCESS,
  FETCH_BREADCRUMBS_FAILURE,
} from 'actionTypes';

import createReducer from './createReducer';

const initialState = {};

const seo = createReducer(initialState, {
  [FETCH_SEO_META_REQUEST]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...(state[action.payload.url] || {}),
      meta: {
        ...action.payload,
        isFetching: true,
        isRequestFailed: false,
        isLoaded: false,
      },
    },
  }),

  [FETCH_SEO_META_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...state[action.payload.url],
      meta: {
        ...action.payload,
        isFetching: false,
        isRequestFailed: false,
        isLoaded: true,
      },
    },
  }),

  [FETCH_SEO_META_FAILURE]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...state[action.payload.url],
      meta: {
        ...action.payload,
        isFetching: false,
        isRequestFailed: true,
        isLoaded: false,
      },
    },
  }),

  [FETCH_SEO_LINKS_BLOCKS_REQUEST]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...(state[action.payload.url] || {}),
      linksBlocks: {
        ...action.payload,
        isFetching: true,
        isRequestFailed: false,
        isLoaded: false,
      },
    },
  }),

  [FETCH_SEO_LINKS_BLOCKS_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...state[action.payload.url],
      linksBlocks: {
        ...action.payload,
        isFetching: false,
        isRequestFailed: false,
        isLoaded: true,
      },
    },
  }),

  [FETCH_SEO_LINKS_BLOCKS_FAILURE]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...state[action.payload.url],
      linksBlocks: {
        ...action.payload,
        isFetching: false,
        isRequestFailed: true,
        isLoaded: false,
      },
    },
  }),

  [FETCH_SEO_TEXTS_BLOCKS_REQUEST]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...(state[action.payload.url] || {}),
      texts: {
        ...action.payload,
        isFetching: true,
        isRequestFailed: false,
        isLoaded: false,
      },
    },
  }),

  [FETCH_SEO_TEXTS_BLOCKS_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...state[action.payload.url],
      texts: {
        ...action.payload,
        isFetching: false,
        isRequestFailed: false,
        isLoaded: true,
      },
    },
  }),

  [FETCH_SEO_TEXTS_BLOCKS_FAILURE]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...state[action.payload.url],
      texts: {
        ...action.payload,
        isFetching: false,
        isRequestFailed: true,
        isLoaded: false,
      },
    },
  }),

  [FETCH_BREADCRUMBS_REQUEST]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...(state[action.payload.url] || {}),
      breadcrumbs: {
        isFetching: true,
        isRequestFailed: false,
        isLoaded: false,
      },
    },
  }),

  [FETCH_BREADCRUMBS_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...state[action.payload.url],
      breadcrumbs: {
        items: action.payload.items,
        isFetching: false,
        isRequestFailed: false,
        isLoaded: true,
      },
    },
  }),

  [FETCH_BREADCRUMBS_FAILURE]: (state, action) => ({
    ...state,
    [action.payload.url]: {
      ...state[action.payload.url],
      breadcrumbs: {
        isFetching: false,
        isRequestFailed: true,
        isLoaded: false,
      },
    },
  }),
});

export default seo;
